import { render, staticRenderFns } from "./TheHeaderDropdownLang.vue?vue&type=template&id=a043d3da&scoped=true&"
import script from "./TheHeaderDropdownLang.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownLang.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderDropdownLang.vue?vue&type=style&index=0&id=a043d3da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a043d3da",
  null
  
)

export default component.exports